import React, { Component } from 'react'
import OnScroll from 'react-on-scroll';
import styles from './styles.scss';

class Sticky extends React.Component {
	state = {
		sticky: false,
	};

	setSticky = sticky => {
        const { callback } = this.props

        this.setState({ sticky }, callback ? callback(!sticky) : null)
    }

	render() {
		const { children } = this.props;
		const { sticky } = this.state;
		return (
			<OnScroll
				className="section"
				triggers={[
					{ top: 0, callback: visible => this.setSticky(visible) },
				]}
			>
				<div>
					<div className={`${"sticky-wrapper"} ${!sticky ? "isSticky": null}`}>
                        {children}
					</div>
				</div>
			</OnScroll>
		);
	}
}

export default Sticky;